/**
 * Текущая дата в часовом поясе Москвы (UTC+3).
 */
export default function getCurrentMoscowDate(): Date {
  const moscowDate = new Date()
  const timezoneOffsetToServer = moscowDate.getTimezoneOffset() + 180

  moscowDate.setMinutes(moscowDate.getMinutes() + timezoneOffsetToServer)

  return moscowDate
}
